import { render, staticRenderFns } from "./income-pie-charts.vue?vue&type=template&id=4dfa81bb"
import script from "./income-pie-charts.vue?vue&type=script&lang=js"
export * from "./income-pie-charts.vue?vue&type=script&lang=js"
import style0 from "./income-pie-charts.vue?vue&type=style&index=0&id=4dfa81bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports